<template>
    <div class="wrap" v-loading.fullscreen.lock="screen_loading">
        <!--详情-->
        <div class="wrap-list">
            <div class="title-btn">
                <span  class="title-back" @click="goBack">返回</span>
                <span  class="title-doc">{{ folderName }}</span>
    
                <!--bu合伙人才有上传入口-->
                <div v-if="type == 'tpl' && userInfo.buIdentityType == 1" class="front-btn green">
                    <input id="doc" type="file" multiple @change="uploadFile($event)">上传
                </div>
            </div>
    
            <!--模板列表-->
            <div class="table-wrap">
                <!--任务文档-->
                <div class="head">
                    <div v-for="(text,index) in list.headtext" :key="text">{{  index == 0 && type == "doc"? "文档编号": text }}</div>
                </div>
                <z-scrollDiv class="detail">
                    <div class="list-item" v-for="lists in listData" :key="lists.id">
                        <div>{{ lists.code }}</div>
                        <div>{{ lists.created_at | justDate }}</div>
                        <div>{{ lists.real_name }}</div>
                        <div class="overhide" :title="lists.doc_name || lists.tpl_doc_name">{{lists.doc_name || lists.tpl_doc_name }}</div>
                        <div>
                            <a @click="downloadFile(lists.id)">下载</a>
                            <a v-if="type =='tpl' &&  lists.tpl_doc_type == 2 && lists.user_id==userInfo.id"  @click="del(lists.id)">删除</a>
                        </div>
                    </div>
                    <z-noData :list="listData"></z-noData>
                </z-scrollDiv>
    
            </div>
        </div>
    
        <!--分页-->
        <z-pagination @getPage="refresh" :data='data'></z-pagination>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    data() {
        return {
            list: {
                headtext: ["模板编号", "发布时间", "创建者", "模板名称", "操作"],
            },
            data: {},
            screen_loading:false,  //锁屏

            // ***需改 用不到
        }
    },
    computed: {
        id() {   //具体id
            return this.$crypto.decrypt(this.$route.params.id);
        },
        folderName(){  //头部名称
            return this.$crypto.decrypt(this.$route.query.name);
        },
        type() {  // 类型 字符串
            return this.$route.params.type;
        },
        url() {  //请求的地址
            if(this.type == "doc"){
                return `api/clerk/task_doc/${this.id}`
            }else{
                return `api/clerk/task_tpl/${this.id}/doc`
            }
        },
        listData() {
            return this.data.list;
        },
        ...mapState(['userInfo']),
    },

    created() {
        this.$func.getUserInfo(true);  //拿取登录用户数据
        this.refresh();
    },

    methods: {
        goBack() {   //回退
            this.$router.go(-1);
        },
        refresh(page) {   //更新数据
            let obj = {page:page};
            this.$http.get(this.url, {params:obj}).then(res => {
                if(res.status == 200){
                    this.data = res.res_data;
                }
            });
        },
        // makename(lists) {
        //     if (this.type == "doc") {
        //         return this.allUserInfo[lists.user_id == null ? 1 : lists.user_id].real_name;
        //     } else {
        //         if (lists.bu_id == "0") {
        //             return "管理员";
        //         }
        //         return `${this.allBuInfo[lists.bu_id].bu_name} - ${this.allUserInfo[lists.user_id].real_name}`;
        //     }

        // }, 
        makedown(id) {  //构造下载链接
            let key = this.type == "doc" ? "task" : "tpl";
            return `api/clerk/${key}_doc/${id}/download`;
        },

        uploadFile(event) {  //上传文件
            let files = event.target.files;

            let formData = new FormData();            
            for(let i = 0,len = files.length;i<len;i++){
                formData.append('task_tpl_doc', files[i]);
            }

            this.screen_loading = true;

            let url = `api/clerk/task_tpl/${this.id}/doc_upload`;
            this.$http.post(url, formData, {
                transformRequest: [function (data) {
                    return data;
                }]
            }).then(res => {
                if(res.status == 200){
                    this.refresh();
                    this.successTip("上传成功");
                }
                this.screen_loading = false;
            }).catch(err=>{
                this.screen_loading = false;
                this.errorTip("出错了");
            })
        },
        downloadFile(id){  //下载文件
            this.$http.get(this.makedown(id));
        },

        del(id) {   //删除文件
            let url =`api/clerk/tpl_doc/${id}`;
            this.$http.delete(url).then(res => {
                if(res.status == 200){
                    this.refresh();
                    this.successTip("删除成功");
                }
            }).catch(err=>{
                this.errorTip("删除失败");
            });
        },

    }
}
</script>

<style lang="less" scoped>
@import "~src/assets/less/var.less";

@mar : 5px;  //列之间间隔
@padd: 30px;  //列表左侧 padding

.wrap {
    height: calc(~"100% - @{front_head_h}");
}

.wrap-list {
    position: relative;
    height: calc(~"100% - @{page-h}");

    .title-btn{
        height: 30px;
        line-height: 30px;
        overflow:hidden;
        padding:15px 0;
        position: relative;
        .title-back {
            display: inline-block;
            font-size: 18px;
            color: #808080;
            letter-spacing: 1.99px;
            text-align: left;
            padding-left: 30px;
            margin-left: 20px;
            background: url("~src/assets/image/Stroke1.png") no-repeat left top;
            cursor: pointer;
        }

        .title-doc {
            font-size: 14px;
            color: #03b1a9;
            letter-spacing: 0.99px;
            text-align: left;
            margin-left: 10px;
            vertical-align: top;
        }
        
        >.front-btn{
            position: absolute;
            left:calc(~"90% - 10px");
            top:50%;
            transform: translateY(-50%);
            input{
                position: absolute;
                width:100%;
                height: 100%;
                top:0;
                left: 0;
                z-index:1;
                cursor: pointer;
                opacity: 0;
            }
        }
    }

}

// 页面主区
.table-wrap {
    height:calc(~"100% - 30px - 30px");
    padding:0 10px;
    .head {
        border-radius: 4px;
        overflow: hidden;
        zoom: 1;
        background: #ffffff;
        box-shadow: 0px 0px 2px 0px rgba(178, 178, 178, 0.50);
        height: 60px;
        line-height: 60px;
        font-size: 14px;
        color: #333333;
        letter-spacing: 0.99px;
        padding-left: @padd;
    }

    // list列表
    .detail {
        height: calc(~"100% - 60px");
        padding-top:@mar;
        box-sizing: border-box;
        .list-item{
            height: 50px;
            line-height: 50px;
            // text-align: center;
            font-size: 12px;
            color: #808080;
            overflow: hidden;
            padding-left: @padd;
            border-radius: 4px;
            background:#fff;
            margin-top: @mar;
            transition:0.3s;
            &:hover{
                background:@list_hover;
            }
            &:first-child{
                margin-top:0;
            }
        }
    }
}


.detail .list-item>div,.head >div{
    &{
        float: left;
    }

    &:nth-of-type(1){
        width:20%;
    }
    &:nth-of-type(2){
        width:20%;
    }
    &:nth-of-type(3){
        width:20%;
    }
    &:nth-of-type(4){
        width:27%;
        padding-right: 3%;
    }
    &:nth-of-type(5){
        width:10%;
        a{
            cursor:pointer;
        }
        :nth-child(1){
            color:@blue;
            margin-right: 10px;
        }
        :nth-child(2){
            color:@red;
        }
    }
}
</style>




// WEBPACK FOOTER //
// page-docList.vue?5f905dd4